import Model     from '@/util/models';
import Kompetisi from './Kompetisi';
import Dapil     from './Dapil';
import Partai    from './Partai';

export default class Calon extends Model { 
    //backend = '/frc/kompetisi/'; 
    backend = '/frc/calon/'; 
   
    kompetisi(params){
      let model = new Kompetisi();
      return model.one(params);
    }
    
    dapil(params){
      let model = new Dapil();
      return model.one(params);
    }   
    
    partais(params){
      let model = new Partai();
      return model.all(params);
    }
    
    partai(params){
      let model = new Partai();
      return model.one(params);
    }
    
    kompetisiDapils(params){
      return this.api.get(this.backend + 'kompetisi-dapils', params).then(res => {
        return res.status === 200 ? res.data : [];
      })
    }
    
    setavatar(formdata){
        return this.api.post(this.backend + 'setavatar', formdata, null, {
          'accept': 'application/json',
          'Accept-Language': 'en-US,en;q=0.8',
          'Content-Type': `multipart/form-data; boundary=${formdata._boundary}`,
        });
    }
    
    getavatar(params){
        return this.api.get(this.backend + 'getavatar', params); 
    }
    
    getavatarThumb(params){
        return this.api.get(this.backend + 'getavatar-thumb', params); 
    }
}

